import { render } from "./PortfolioModal.vue?vue&type=template&id=28ee6497&scoped=true"
import script from "./PortfolioModal.vue?vue&type=script&lang=js"
export * from "./PortfolioModal.vue?vue&type=script&lang=js"

import "./PortfolioModal.vue?vue&type=style&index=0&id=28ee6497&lang=scss&scoped=true"

import exportComponent from "/opt/render/project/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28ee6497"]])

export default __exports__